import React, { useEffect, useState } from 'react';
//import ReactDOM from 'react-dom/client';
import { createRoot } from 'react-dom/client'
import { SociogramRender } from './pages/sociogram/sociogram';
import { SocioGroupRender } from './pages/groups/groups';
import { People } from './pages/people/people';
import { ManagePerson } from './pages/people/manage-person';
import { ListSociograms } from './pages/sociogram/list-sociograms';
import { CreateSociogramForm } from './pages/sociogram/create-sociogram';
import UpdateSociogramFormWrapper from './pages/sociogram/update-sociogram';
import { SubmitEntryForm } from './pages/entries/submit-entry';
import { SubmitEntryUnauthenticatedForm } from './pages/entryunauthenticated/submit-entry';
import { Dashboard } from './pages/dashboard/dashboard';
import { Login } from './pages/login/login';
import { LogoutComponent } from './pages/logout/logout'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import { Callback } from './pages/login/callback';
//import Auth from './services/auth-service'
import headerImg from './images/white-large.png';
import { Navigation } from './components/navigation';
import toast, { Toaster } from 'react-hot-toast';
import './style/site.css';
import Auth2Service from './services/auth2-service'


  //const auth = new Auth();

  // const handleAuthentication = (nextState, replace) => {
  //   if (/access_token|id_token|error/.test(nextState.location.hash)) {
  //     auth.handleAuthentication();
  //   }
  // }

  // const logout = (nextState, replace) => {
  //   auth.logout();
  // }

  import { useAuth0 } from '@auth0/auth0-react';
import { PeopleManagement } from './pages/people/people-management';

  const notify = () => toast('Here is your toast.');




  
  const App = () => {
    const { getAccessTokenSilently, isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
    const [accessToken, setAccessToken] = useState(null);
    const { logout } = useAuth0();
    const handleLogout = () => {
      logout({
        logoutParams: {
          returnTo: window.location.origin // This specifies where to redirect after logout
        }
      });
    }
    useEffect(() => {
      // Automatically redirect to login if not authenticated
      if (!isAuthenticated && !isLoading) {
        loginWithRedirect();
      }

      const fetchToken = async () => {
        if (isAuthenticated && !isLoading) {
          try {
            const token = await getAccessTokenSilently({
              authorizationParams: {},
            });
            setAccessToken(token);
          } catch (error) {
            console.error('Error fetching access token:', error);
          }
        }
      };
  
      fetchToken();

    }, [isAuthenticated, isLoading, loginWithRedirect]);

    if (isLoading || !isAuthenticated || !accessToken) {
      return <div>Loading...</div>;
    }
    
    return (
      <div class="main">
        <div class="header">
          <img class="titleHeader" src={headerImg} />
          <Navigation />
          <Toaster toastOptions={{
          // Define default options
          className: '',
          duration: 7000,
          removeDelay: 2000,
        }}/>
        </div>
        <div class="content">
          <Routes>
            <Route path="/" element={<Dashboard accessToken={accessToken} toaster={notify} />} />
            <Route path="/sociogram" element={<ListSociograms accessToken={accessToken} />} />
            <Route path="/sociogram/:id" element={<SociogramRender accessToken={accessToken} />} />
            <Route path="/people" element={<People accessToken={accessToken} />} />
            <Route path="/people/:id" element={<ManagePerson accessToken={accessToken} />} />
            <Route path="/peoplemgmt" element={<PeopleManagement accessToken={accessToken} />} />
            <Route path="/login" element={<Login accessToken={accessToken} />} />
            <Route path="/entry/:sociogram/:account" element={<SubmitEntryUnauthenticatedForm accessToken={accessToken} />} />
            <Route path="/groups/:id/:size" element={<SocioGroupRender accessToken={accessToken} />} />
            <Route path="/logout" element={<LogoutComponent />} />
            {/* <Route path="/logout" render={(props) => {
              handleLogout();
              return <Callback {...props} /> 
            }}/> */}
            <Route path="/create" element={<CreateSociogramForm accessToken={accessToken} />} />
            <Route path="/update/:sociogramId" element={<UpdateSociogramFormWrapper accessToken={accessToken} />} />
            <Route path="/entries" element={<SubmitEntryForm accessToken={accessToken} />} />
            <Route path="/callback" render={(props) => {
              handleAuthentication(props);
              return <Callback {...props} /> 
            }}/>
          </Routes>
        </div>
      </div>
    );
  }
  

  const rootElement = document.getElementById('root');
  const root = createRoot(rootElement);
  root.render((
    <Router>
      <Auth2Service>
        <App />
      </Auth2Service>
    </Router>
  ), document.getElementById('root'))